import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgLines3 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M20 12q0 1-1 1H5q-1 0-1-1t1-1h14q1 0 1 1M20 17q0 1-1 1H5q-1 0-1-1t1-1h14q1 0 1 1M20 7q0 1-1 1H5Q4 8 4 7t1-1h14q1 0 1 1'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgLines3)
export default ForwardRef
